import { gql } from '@src/lib/gql'

/** Chat tools an operator can run Generate through. The screen drops apps and admin-only tools. */
export const CHAT_GENERATE_TOOLS = gql`
  query ChatGenerateTools($order: [[String]], $pageSize: Int) {
    scoTools(order: $order, pageSize: $pageSize) {
      items {
        toolId
        title
        slug
        audienceKey
        toolTypeKey
      }
    }
  }
`
